import { Rule } from "antd/es/form";
import { useMemo } from "react";
import { transformToFloat } from "../../../lib/transformToFloat";

export const useAmountRules = (isRegularAmount: boolean) => {
  const MIN_AMOUNT = 10;
  const MAX_AMOUNT = 15000;

  const rules = useMemo(() => {
    return isRegularAmount
      ? []
      : [
          () => ({
            validateTrigger: "onSubmit",
            validator(_: Rule, value: string) {
              const val: number | null = transformToFloat(value);

              if (!val) {
                return Promise.reject(new Error("Please enter an amount"));
              }

              if (val < MIN_AMOUNT || val > MAX_AMOUNT) {
                return Promise.reject(
                  new Error(
                    `Amount must be between $${MIN_AMOUNT} and $${MAX_AMOUNT}`,
                  ),
                );
              }

              return Promise.resolve();
            },
          }),
        ];
  }, [isRegularAmount]);

  return { rules };
};
